import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import LaddaButton, { SLIDE_DOWN } from 'react-ladda';

import Input from '../common/input';
import Textarea from '../common/textarea';
import DefaultSelect from '../common/select';
import {
  requiredField,
  emailField,
  numericFieldWhereNotStartWithZero,
  phoneField,
} from '../../helpers/validator';

import BookingCalendar from './booking-calendar';

let ServiceDetailsForm = ({ handleSubmit, isLoading, errorMessage }) => {
  // if postcode change(or if they are not unique) then we need change logic on API route also
  const options = [
    {
      label: 'City',
      value: 'Regeringsgatan 17',
      postcode: '111 53',
      latitude: 59.33074330667878,
      longitude: 18.068092161935812,
    },
    {
      label: 'Liljeholmen',
      value: 'Årstaängsvägen 21C',
      postcode: '117 43',
      latitude: 59.3095028,
      longitude: 18.0278797,
    },
  ];

  return (
    <form onSubmit={handleSubmit}>
      <Field
        type="text"
        name="first_name"
        label="Namn"
        className="form-control"
        placeholder="Ange ditt förnamn"
        component={Input}
      />
      <Field
        type="text"
        name="last_name"
        label="Efternamn"
        className="form-control"
        placeholder="Ange ditt efternamn"
        component={Input}
      />
      <Field
        type="text"
        name="email"
        label="E-post"
        className="form-control"
        placeholder="Din e-postadress"
        component={Input}
      />
      <hr className="line" />
      <Field
        name="address"
        label="Verkstad"
        options={options}
        placeholder="Välj verkstad"
        component={DefaultSelect}
      />
      <hr className="line" />
      <Field
        name="note"
        label="Ärende"
        className="form-control"
        placeholder="Beskriv kortfattat (valfritt)"
        component={Textarea}
      />
      <hr className="line" />
      <Field
        type="tel"
        name="phone_number"
        label={
          <>
            Ditt mobilnummer
            <br />
            <span className="format-label">(utan 0 i början och inga mellanslag)</span>
          </>
        }
        countryCode="+46"
        className="form-control"
        placeholder="Mobilnummer"
        component={Input}
      />
      <hr className="line" />
      <BookingCalendar />

      <LaddaButton className="btn w-100 submit-button" disabled={isLoading} data-style={SLIDE_DOWN}>
        Boka
      </LaddaButton>
      <p className="text-danger text-center">{errorMessage}</p>
    </form>
  );
};

const serviceDetailsFormValidator = (values) => {
  const errors = {};
  requiredField(values, errors, 'first_name', 'VALIDATION.FIRST-NAME.ERROR_REQUIRED');
  requiredField(values, errors, 'last_name', 'VALIDATION.LAST-NAME.ERROR_REQUIRED');
  requiredField(values, errors, 'email', 'VALIDATION.EMAIL.ERROR_REQUIRED');
  requiredField(values, errors, 'address', 'VALIDATION.ORGANIZATION-NAME.ERROR_REQUIRED');
  requiredField(values, errors, 'phone_number', 'VALIDATION.TOS.ERROR_REQUIRED');
  emailField(values, errors, 'email', 'VALIDATION.EMAIL.WRONG_FORMAT');
  numericFieldWhereNotStartWithZero(
    values,
    errors,
    'phone_number',
    'VALIDATION.TOS.WRONG_NUMERIC_FORMAT'
  );
  phoneField(values, errors, 'phone_number', 'VALIDATION.TOS.WRONG_FORMAT');

  return errors;
};

ServiceDetailsForm = reduxForm({
  form: 'service-details',
  validate: serviceDetailsFormValidator,
})(ServiceDetailsForm);

ServiceDetailsForm = connect((state) => ({
  initialValues: state.service.user,
}))(ServiceDetailsForm);

export default ServiceDetailsForm;
